<template>
    <v-parallax
        v-if="currentPage === 'home'"
        src="https://connectv2.d3llc.org/images/World-map.jpg"
        height="100%"
        class="fixed-home"
    >
        <div class="digital-calander">
            <span>{{ currentDate }}</span>
        </div>

        <div class="digital-clock">
            <span>{{ currentTime }}</span>
        </div>

        <v-alert
            v-model="showAlert"
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            type="error"
            title="Employee is not required to punch!"
            text="El empleado no está obligado a marcar entrada!"
        ></v-alert>

        <v-alert
            v-model="showAlert2"
            class="mx-16"
            style="justify-content: center; margin-top: 16px"
            type="error"
            title="Shift is not set up. Please see your supervisor!"
            text="El turno no está configurado. Por favor, consulte con su supervisor!"
        ></v-alert>

        <v-row class="center-container" justify="center">
            <v-col cols="6" lg="6" md="9" sm="9" xs="9" class="text-center">
                <label style="color: black; font-size: 40px">
                    Enter Employee ID
                </label>
                <v-text-field
                    @change="scannerInputChange"
                    v-model="employeeID"
                    style="color: black"
                    clearable
                    label="Employee ID"
                    variant="solo-inverted"
                    ref="employeeInput"
                ></v-text-field>
                <!--                <v-btn color="green" block @click="enterLoggedInPage">-->
                <!--                    Submit-->
                <!--                    <v-icon left style="margin-left: 10px"-->
                <!--                        >mdi:mdi-arrow-right-->
                <!--                    </v-icon>-->
                <!--                </v-btn>-->
                <v-alert
                    v-if="error"
                    color="red"
                    class="mt-15"
                    :text="this.error"
                ></v-alert>
            </v-col>
        </v-row>
    </v-parallax>

    <!--View LoggedIn Page-->
    <div v-if="currentPage === 'loggedInPage'">
        <LoggedIn
            v-on:clockin="enterLoggedInPage"
            :employeeInfo="employeeInfo"
        />
        <!-- Pass the employeeInfo as props -->
    </div>
    <!--End LoggedIn-->
</template>
<script>
import GuestLayout from "../../Layouts/GuestLayout.vue";
import axios from "axios";
import LoggedIn from "./LoggedIn.vue";
import debounce from "lodash/debounce";

export default {
    components: {
        LoggedIn,
    },
    props: {
        errors: Object,
        auth: Object,
    },
    layout: [GuestLayout],
    data: () => ({
        currentTime: "",
        currentDate: "",
        currentPage: "home",
        error: null,
        employeeID: null,
        tableItems: [],
        employeeInfo: {}, // Initialize an empty object to hold the employee information
        showAlert: false,
        showAlert2: false,
        routePrefix: '',
    }),

    watch: {
        employeeID(newVal) {
            if (newVal) {
                // Strip all non latin1_swedish_ci characters
                this.employeeID = newVal
                    .normalize("NFD") // splits accented characters into base + accent (ex. ĥ -> h + accent)
                    .replace(/[\u0300-\u036f]/g, "") // remove accents
                    .replace(/[^a-zA-Z0-9_-]/g, ""); // allow only safe characters
            }
        },
    },

    mounted() {
        this.routePrefix = this.$page.props.routePrefix || 'legacy-api.'; // Get the routePrefix from the page props
        this.$refs.employeeInput.focus();
        this.updateTime();
        setInterval(this.updateTime, 1000); // Update time every second
    },

    methods: {
        updateTime() {
            const now = new Date();
            this.currentTime = now.toLocaleTimeString();
            this.currentDate = now.toLocaleDateString();
        },
        scannerInputChange: debounce(async function () {
            //@input
            /**
             *  debounce function is typically used to delay the execution of a function until after a
             *  certain period of time has passed since the last invocation. This is useful when
             *  you want to handle an event like user input, but you want to wait for a short
             *  delay to ensure that the function is not called too frequently.
             */

            await this.enterLoggedInPage();
        }, 400),

        async enterLoggedInPage() {
            try {
                this.currentPage = "home";
                const response = await axios.get(
                    route(`${this.routePrefix}punch-fetchEmployeeInfo`, {
                        empID: this.employeeID,
                    })
                );
                this.employeeInfo = response.data[0]; // Store the first object from the API response in employeeInfo
                this.employeeInfo.ID = this.employeeID;
                this.employeeInfo.tableItems = response.data["Recent"];
                this.error = null;

                if (this.employeeInfo.HourlyEmployee_c == 0) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.showAlert = false;
                    }, 5000);
                } else if (this.employeeInfo.Shift == 999) {
                    this.showAlert2 = true;
                    setTimeout(() => {
                        this.showAlert2 = false;
                    }, 5000);
                } else {
                    //You passed the test!
                    this.currentPage = "loggedInPage";
                }
            } catch (err) {
                if (this.employeeID == null) {
                    this.error = "Please Enter Employee ID";
                    setTimeout(() => {
                        this.error = null;
                    }, 5000);
                } else {
                    this.error = "Please Enter Valid Employee ID";
                    setTimeout(() => {
                        this.error = null;
                    }, 5000);
                }
            }
        },
    },
};
</script>

<style lang="css" scoped>
.center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35%;
}

.digital-clock {
    font-size: 2.3rem;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.digital-calander {
    font-size: 1.5rem;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fixed-home {
    position: fixed;
    width: 100%;
    top: 64px;
    left: 0;
    overflow: hidden;
}
</style>
